/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Event Safety Icon component.
 */
export const EventSafetyIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M19.9757 34.5456C19.8734 34.5809 19.7574 34.5809 19.6551 34.5456C9.23185 30.9443 8.1302 18.0782 8.01376 15.3988C8.00177 15.1229 8.22394 14.9086 8.49993 14.8992C10.6208 14.8274 12.7035 14.2992 14.605 13.3484C16.4568 12.4225 18.0909 11.1189 19.4035 9.52414C19.6153 9.26677 20.0155 9.26677 20.2273 9.52414C21.5398 11.1189 23.1739 12.4225 25.0257 13.3484C26.9273 14.2992 29.0099 14.8274 31.1308 14.8992C31.4068 14.9086 31.629 15.1229 31.617 15.3988C31.5006 18.0782 30.3989 30.9444 19.9757 34.5456Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M15.8735 22.7842L17.8428 24.7534L23.7505 18.8457' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
    </svg>
  );
};

export default EventSafetyIcon;
